<template>
  <li :class="['h-menu-li', handleOPenMenuClass]" @click="handleOpenMenu">
       <div  content="Metas" placement="right" class="h-menu-show">
          <span  class="h-menu-show-icon">
            <i :class="icon" v-tooltip placement="right" :content="label"></i>
          </span>
          <span  v-if="!siderCollapsed" class="h-menu-show-desc">{{label}}</span>
          <span  v-if="!siderCollapsed" class="h-menu-show-expand">
            <i class="h-icon-angle-down"></i>
          </span>
        </div>
       <ul class="h-menu-ul"  @click="handleItemClick">
        <slot />
     </ul>
     </li>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'MenuItemDropDown',
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: () => ''
    }
  },
  data: () => ({
    isOpen: true
  }),
  methods: {
    handleItemClick() {
      this.handleOpenMenu(); // previne fechar o menu quando clica num item
    },
    handleOpenMenu() {
      this.isOpen = !this.isOpen;
    }
  },
  computed: {
    ...mapState({
      siderCollapsed: state => state.siderCollapsed
    }),
    handleOPenMenuClass() {
      return this.isOpen ? 'h-menu-li-opened' : '';
    }
  }
};
</script>

<style>

</style>
